import { PDFDocument, PageSizes } from "pdf-lib";
import { generatePdf } from "./generatePdf";

export const mergePdf = async ({data, position = {x: 0, y: 0}}) => {
  // Get Base PDF for Url
  const pdfBaseBytes = await fetch(data.flyerUrl).then((res) => res.arrayBuffer());
  
  // Generate PDF with Loan Officer Info
  const loPdfBytes = await generatePdf(data);
  // Create Blank PDF
  const pdfDoc = await PDFDocument.create();
  
  // Add PdfBytes to New PDF
  const [base] = await pdfDoc.embedPdf(pdfBaseBytes);
  const loadedLoBytes = await PDFDocument.load(loPdfBytes);
  const info = await pdfDoc.embedPage(loadedLoBytes.getPages()[0]);
  const baseDims = base.scale(1);
  const infoDims = info.scale(1);
  
  // Add PDFs to Same Page
  const page = pdfDoc.addPage(PageSizes.Letter);
  page.drawPage(base, {
    ...baseDims,
  });
  page.drawPage(info, {
    ...infoDims,
    x: page.getWidth() / 2 - infoDims.width / 2 - position.x,
    y: page.getHeight() / 2 - infoDims.height / 2 - position.y,
  });

  // Save and Download New PDF
  const pdfBytes = await pdfDoc.save();
  downloadPDF({pdfBytes, pdfName: data.productName});
}

const downloadPDF = ({pdfBytes, pdfName}) => {
  // Create URL Blob for PDF
  const blob = new Blob([pdfBytes], {type: "pdf"});

  // Trigger the browser to download the PDF document
  const href = URL.createObjectURL(blob);
  const link = Object.assign(document.createElement('a'), {href, style:"display:none", download:`${pdfName}.pdf`})
  link.dispatchEvent(new MouseEvent('click'));

  // Destroy link to avoid memory leak
  URL.revokeObjectURL(href);
  link.remove();
}